module.exports = __webpack_public_path__ + "static/bg-cast-header-1920-744e12c17932b80e18ad962f8cb6252a.jpg";